import { outlierText } from '../../shared/outlier-copy.js';
import { getDisplayUnits } from './units.js';
import { readSalinityUnit } from './salinity.js';

// The outlier warning in the keeper's units (°C, S.G.), from the numbers
// the server kept. Rows saved before outlier_detail existed only have the
// storage-unit sentence, so it stays the fallback.
export function outlierMessage(row, tank) {
  if (!row) return null;
  const units = { temp: getDisplayUnits(tank).temp, salinity: readSalinityUnit() };
  return (
    (row.outlier_detail && outlierText(row.outlier_detail, units)) || row.outlier_reason || null
  );
}
